export const BACKEND_API_URL = "https://3mpmonitoring.com/api";
export const BACKEND_OAUTH_URL = "https://3mpmonitoring.com/oauth";
export const AUTH_STORAGE_KEY = "authCredentials";
export const GOOGLE_MAPS_API_KEY = "AIzaSyC-E4hN6JrKIslwBPTCmcYvvGh0zh1uuWk";
export const SUPPORT_EMAIL = "podrska@3mpmonitoring.rs";
export const APP_VERSION = "";
